// three-stdlib (non "three/examples/jsm/..." direttamente): stessa libreria già usata
// internamente da @react-three/drei per il rendering nel kiosk (vedi
// node_modules/@react-three/drei/core/Gltf.js) — importarla da qui invece che dai moduli
// "three/examples/jsm" evita di impacchettare DUE copie separate del decoder Draco
// (verificato: con "three/examples/jsm" il bundle di produzione duplicava draco_decoder.js/
// draco_wasm_wrapper.js, +16KB extra nel bundle principale per nulla).
import { GLTFLoader, DRACOLoader } from "three-stdlib";

// Stesso decoder Draco (stessa versione/URL) già usato da @react-three/drei per renderizzare i
// modelli nel kiosk (vedi node_modules/@react-three/drei/core/Gltf.js) — un .glb con le mesh
// compresse in Draco ha bisogno di questo anche solo per essere letto, non solo per essere
// disegnato: senza, loader.loadAsync() fallisce a prescindere da cosa serve davvero al
// chiamante (qui solo l'elenco delle animazioni).
const DRACO_DECODER_PATH = "https://www.gstatic.com/draco/versioned/decoders/1.5.5/";

let dracoLoader = null;
function getLoader() {
  const loader = new GLTFLoader();
  if (!dracoLoader) {
    dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath(DRACO_DECODER_PATH);
  }
  loader.setDRACOLoader(dracoLoader);
  return loader;
}

// Elenca i nomi (Animation.name) delle clip di animazione di un .glb/.gltf — usato dal pannello
// Avatar (ProjectManager.js) per popolare i menu a tendina idle/corpo-mentre-parla/labiale-
// mentre-parla SENZA dover renderizzare il modello in un <Canvas> solo per leggerne le
// animazioni (vedi AvatarCanvas.js per dove queste clip vengono effettivamente suonate nel
// kiosk). Lancia se l'URL non è raggiungibile o il file non è un .glb/.gltf valido — nessun
// fallback silenzioso qui, è compito del chiamante mostrare l'errore.
export async function listGlbAnimationClips(url) {
  const loader = getLoader();
  const gltf = await loader.loadAsync(url);
  return (gltf.animations || []).map((a) => a.name).filter(Boolean);
}
